<template>
    <div id="contentViewPage" class="fade-in">
        <nav id="siteNavBar" class="navbar navbar-expand-lg bg-body-tertiary">
            <div class="container-fluid">
                <a class="navbar-brand" href="#mainContent">
                    <img id="logoNavBar" src="../assets/logo.png" alt="logo">
                    <b>
                        Grupo Colab
                    </b>
                </a>

                <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                        <li class="nav-item">
                            <a class="nav-link" aria-current="page" href="#quem-somos">
                                <i class="bi bi-code-slash"></i>
                                Quem somos?
                            </a>
                        </li>

                        <li class="nav-item">
                            <a class="nav-link" href="#membros">
                                <i class="bi bi-people-fill"></i>
                                Membros
                            </a>
                        </li>

                        <li class="nav-item">
                            <a class="nav-link" href="#servicos">
                                <i class="bi bi-hammer"></i>
                                Serviços
                            </a>
                        </li>

                        <li class="nav-item">
                            <a class="nav-link" href="#doacao">
                                <i class="bi bi-cash-coin"></i>
                                Doação
                            </a>
                        </li>
                    </ul>

                    <!-- <form class="d-flex" role="search">
                        <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
                        <button class="btn btn-outline-success" type="submit">Search</button>
                    </form> -->
                </div>
            </div>
        </nav>

        <div class="container">
            <div id="mainContent">
                <div id="quem-somos" class="container bg-dark text-white d-flex flex-wrap containerShadow"
                    style="border-radius: 10px; padding: 10px; margin-bottom: 10px;">
                    <!--Luiz Trindade - Primeira linha do site-->
                    <div class="row">
                        <!--Luiz Trindade - Texto quem somos-->
                        <div class="col-md-6">
                            <div class="container">
                                <h1 style="text-align: left;">
                                    <i class="bi bi-code-slash"></i>
                                    <b>
                                        Quem somos?
                                    </b>
                                </h1>
    
                                <p style="text-align: left;" class="fs-5">
                                    Somos o <b>Grupo Colab</b>, um time de estudantes de <b>programação</b> apaixonados por
                                    tecnologia e desenvolvimento de software. Mesmo ainda na faculdade, já trabalhamos
                                    em <b>projetos freelancers</b>, prestamos <b>serviços</b> e entregamos <b>soluções
                                        reais</b>
                                    para empresas e empreendedores.
                                    <br><br>
    
                                    Nossa força está na <b>colaboração</b>, no aprendizado
                                    constante e na entrega de <b>resultados de qualidade</b>.
    
                                    Com um olhar focado no futuro, unimos criatividade e técnica para transformar ideias
                                    em projetos de sucesso. Se você busca inovação e comprometimento, estamos prontos
                                    para colaborar e construir juntos!
                                </p>
                            </div>
                        </div>
    
                        <!--Luiz Trindade - Imagem-->
                        <div class="col-md-6">
                            <div class="container"
                                style="padding-bottom: 50px; display: flex; align-items: center; justify-content: center; flex-direction: column;">
                                <img src="../assets/logo.png" alt="logo"
                                    style="box-shadow: 2px 4px 5px rgba(0, 0, 0, 0.5); border-radius: 10px; width: 70%;">
                            </div>
                        </div>
                    </div>
                </div>
    
                <!--Luiz Trindade - Membros-->
                <div id="membros" class="container container2 d-flex flex-wrap bg-dark text-white containerShadow"
                    style="border-radius: 10px; margin-top: 20px;">
                    <h1>
                        <i class="bi bi-people-fill"></i>
                        <b>
                            Membros
                        </b>
                    </h1>
    
                    <!--Membros cards-->
                    <div class="row">
                        <!--Luiz Trindade-->
                        <div class="col-md-6">
                            <div class="card">
                                <img src="../assets/membros/luiz_trindade.jpeg" class="card-img-top"
                                    alt="Luiz Gabriel Magalhães Trindade">
                                <div class="card-body">
                                    <h3 class="card-title">
                                        <b>
                                            Luiz Gabriel Magalhães Trindade
                                        </b>
                                    </h3>
                                    <p style="text-align: left;" class="fs-4">
                                        Sou estagiário em programação fullstack e estudante de Ciência da Computação, com
                                        experiência prática em desenvolvimento de software usando <b>Python, Vue.js, PHP,
                                            JavaScript</b> e <b>MySQL</b>. Tenho habilidades em criação de APIs,
                                        desenvolvimento de
                                        interfaces dinâmicas e construção de sistemas integrados, sempre aplicando boas
                                        práticas de código e metodologias ágeis. Defensor do open source, uso <b>Linux</b>
                                        como sistema operacional e valorizo a eficiência e simplicidade no desenvolvimento.
                                        Com uma mentalidade de aprendizado constante, busco me aperfeiçoar continuamente e
                                        me manter atualizado nas tecnologias mais recentes.
                                    </p>
                                </div>
                            </div>
                        </div>
    
                        <!--Lucas Tavares-->
                        <div class="col-md-6">
                            <div class="card">
                                <img src="../assets/membros/lucas_tavares.jpeg" class="card-img-top"
                                    alt="Lucas Gonçalves Tavares">
                                <div class="card-body">
                                    <h3 class="card-title">
                                        <b>
                                            Lucas Gonçalves Tavares
                                        </b>
                                    </h3>
                                    <p style="text-align: left;" class="fs-4">
                                        Acadêmico de Ciência da Computação, com foco em desenvolvimento de software.
                                        Experiência em projetos práticos com linguagens como Python, JavaScript, C, Java e
                                        CSS.
                                        Desenvolvimento de aplicativos móveis. Proativo e comprometido com aprendizado
                                        contínuo,
                                        buscando aplicar e expandir habilidades para contribuir no sucesso de projetos.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
    
                    <div class="row">
                        <!--José Henrique H H Monteiro-->
                        <div class="col-md-6">
                            <div class="card">
                                <img src="../assets/membros/jose_henrique.jpeg" class="card-img-top"
                                    alt="José Henrique H H Monteiro">
                                <div class="card-body">
                                    <h3 class="card-title">
                                        <b>
                                            José Henrique H H Monteiro
                                        </b>
                                    </h3>
                                    <p style="text-align: left;" class="fs-4">
                                        Estudante de Tecnologia da Informação apaixonado por programação, redes e suporte
                                        técnico. Experiência em projetos acadêmicos e habilidades em Python, Java e C. Busco
                                        resolver problemas complexos com soluções eficientes, combinando conhecimento
                                        técnico
                                        com abordagem orientada ao cliente para excelência em atendimento e suporte.
                                    </p>
                                </div>
                            </div>
                        </div>
    
                        <!--Lucas Tavares-->
                        <div class="col-md-6">
                            <div class="card">
                                <img src="../assets/membros/rafael_moraes.jpeg" class="card-img-top"
                                    alt="Rafael Moraes de Souza">
                                <div class="card-body">
                                    <h3 class="card-title">
                                        <b>
                                            Rafael Moraes de Souza
                                        </b>
                                    </h3>
                                    <p style="text-align: left;" class="fs-4">
                                        Estudante de Ciência da Computação na Faci Wyden.
                                        Foco em Desenvolvimento Web.
                                        Estagiário de Monitoramento na Resolve Energia Solar.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                </div>
    
                <!--Luiz Trindade - Serviços-->
                <div id="servicos" class="container container3 d-flex flex-wrap bg-dark text-white containerShadow"
                    style="border-radius: 10px">
                    <h1>
                        <i class="bi bi-hammer"></i>
                        <b>
                            Serviços
                        </b>
                    </h1>
                    <br>
    
                    <!--Luiz Trindade - ColabFood container-->
                    <div class="container">
                        <div class="row">
                            <div class="col">
    
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="container">
                                            <h1 style="text-align: left;">
                                                <b>
                                                    Colab Food (Em testes)
                                                </b>
                                            </h1>
    
                                            <p style="text-align: left;" class="fs-6">
                                                <b>
                                                    Gerencie seu negócio culinário com eficiência! O Colab Food é uma
                                                    plataforma inovadora que reúne cadastro de produtos, vendas e
                                                    acompanhamento de faturamento em uma única ferramenta.
                                                    <br><br>
                                                    - Cadastre facilmente seus produtos e menus <br>
                                                    - Venda mais com nossas ferramentas de gestão de pedidos <br>
                                                    - Acompanhe seu faturamento em tempo real <br>
                                                    - Otimize sua gestão e aumente sua produtividade <br><br>
    
                                                    Acesse agora e descubra como o Colab Food pode transformar seu negócio!
                                                </b>
                                            </p>
                                            <hr>
    
                                            <h3>Já possui um acesso?</h3>
                                            <div class="row" style="margin-top: 30px;">
                                                <div class="col">
                                                    <button class="btn btn-success" @click="redirecionarColabFood()"
                                                        style="box-shadow: 2px 4px 5px rgba(0, 0, 0, 0.5);">
                                                        <i class="bi bi-box-arrow-in-right"></i>
                                                        <b>
                                                            Sim, ir para o login
                                                        </b>
                                                    </button>
                                                </div>
    
                                                <div class="col">
                                                    <button class="btn btn-primary"
                                                        style="box-shadow: 2px 4px 5px rgba(0, 0, 0, 0.5);"
                                                        @click="solicitarAcesso()">
                                                        <i class="bi bi-whatsapp"></i>
                                                        <b>
                                                            Não, solicitar acesso
                                                        </b>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <!--Luiz Trindade - Imagens colab food-->
                                    <div class="col-md-6">
                                        <!--
                                        
                                        <div class="container" style="margin-top: 20px;">
                                            <img src="../assets/logo.png" alt="colabfood"
                                                style="box-shadow: 2px 4px 5px rgba(0, 0, 0, 0.5); border-radius: 10px; width: 80%;">
                                        </div>
                                        -->
                                        <h1 style="text-align: left;">
                                            <i class="bi bi-camera-fill"></i>
                                            <b>
                                                Capturas de tela:
                                            </b>
                                        </h1>
                                        <div id="carouselExampleAutoplaying" class="carousel slide" data-bs-ride="carousel" style="margin-top: 20px;">
                                            <div class="carousel-inner" style="border-radius: 10px; box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.5);">
                                                <!--Luiz Trindade - Login-->
                                                <div class="carousel-item active">
                                                    <img src="../assets/colab-food/carousel/colabfoodlogin.png" class="d-block w-100" alt="...">
                                                </div>
                                                <!--Luiz Trindade - Home-->
                                                <div class="carousel-item">
                                                    <img src="../assets/colab-food/carousel/colabfoodhome.png" class="d-block w-100" alt="...">
                                                </div>
                                                <!--Luiz Trindade - Home2-->
                                                <div class="carousel-item">
                                                    <img src="../assets/colab-food/carousel/colabfoodhome2.png" class="d-block w-100" alt="...">
                                                </div>
                                                <!--Luiz Trindade - Produtos-->
                                                <div class="carousel-item">
                                                    <img src="../assets/colab-food/carousel/colabfoodprodutos.png" class="d-block w-100" alt="...">
                                                </div>
                                                <!--Luiz Trindade - Vendas-->
                                                <div class="carousel-item">
                                                    <img src="../assets/colab-food/carousel/colabfoodvendas.png" class="d-block w-100" alt="...">
                                                </div>
                                                <!--Luiz Trindade - Faturamento-->
                                                <div class="carousel-item">
                                                    <img src="../assets/colab-food/carousel/colabfoodfaturamento.png" class="d-block w-100" alt="...">
                                                </div>
                                            </div>
                                            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
                                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                <span class="visually-hidden">Previous</span>
                                            </button>
                                            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
                                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                <span class="visually-hidden">Next</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <hr>
    
                            </div>
                        </div>
                    </div>
                </div>
    
                <!--Luiz Trindade - Área de doação-->
                <div id="doacao" class="container container4 d-flex flex-wrap bg-dark text-white containerShadow">
                    <div class="row">
                        <div class="col-md-6">
                            <h1 style="text-align: left;">
                                <i class="bi bi-cash-coin"></i>
                                <b>
                                    Doação
                                </b>
                            </h1>
    
                            <p style="text-align: left" class="fs-6">
                                A sua doação via Pix para <b>Luiz Gabriel Magalhães Trindade</b> será um apoio fundamental para
                                o <b>Grupo Colab</b>! Contribuindo com qualquer valor, você estará ajudando diretamente na
                                <b>manutenção, upgrade e aluguel do servidor</b> que hospeda nossos projetos, garantindo a
                                estabilidade e crescimento das nossas iniciativas. 
                                <br><br>
                                Além disso, sua contribuição também será
                                destinada à <b>manutenção do domínio</b>(nome do site), essencial para nossa presença online.
                                Mas não para por aí: sua doação também ajudará a <b>incentivar nossos programadores</b>,
                                oferecendo uma <b>renda extra</b> e promovendo a continuidade e a qualidade dos nossos
                                desenvolvimentos. 
                                <br><br>
                                Cada doação fortalece nosso compromisso em criar soluções inovadoras,
                                colaborativas e sustentáveis. Junte-se a nós nessa jornada e faça a diferença — sua ajuda é
                                essencial para o sucesso de todos!
                            </p>
                        </div>
    
                        <div class="col-md-6">
                            <img src="../assets/doacao_grupo_colab_pix.jpg" alt="doação via pix grupo colab" 
                            style="box-shadow: 2px 4px 5px rgba(0, 0, 0, 0.5); border-radius: 10px; width: 80%;">
                            <br>
    
                            <a href="https://nubank.com.br/cobrar/cqcxyx/67322df8-0e85-4fbb-b90e-d3ba5253d38b" target="_blank" class="fs-4" 
                            style="text-decoration: none; color: white; margin-top: 10px;">
                                <i class="bi bi-cash-coin"></i>
                                <b>Ou se preferir, clique aqui!</b>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--Luiz Trindade - Footer ou Rodapé-->
        <footer id="footerSite" class="bg-dark text-white text-center py-3 mt-auto">
            <div class="container">
                <p class="mb-0">© 2024 Grupo Colab. Todos os direitos reservados.</p>
                <p><a href="#" class="text-white">Termos de Serviço</a> | <a href="#" class="text-white">Política de
                        Privacidade</a></p>
                <p class="d-none d-sm-block">Siga-nos nas redes sociais!</p>
                <p>Este site utiliza código licenciado sob a <a href="https://mit-license.org/" target="_blank">Licença MIT</a>.</p>
            </div>
        </footer>
    </div>
</template>

<script>
//Importação do utils.js
import * as utils from '../utils.js';

export default {
    //Luiz Trindade - Nome do componente
    name: "home",

    //Luiz Trindade - Declaração de variáveis
    data() {
        return {
        };
    },

    //Luiz Trindade - Importação de componentes
    components: {
    },

    //Luiz Trindade - Métodos que serão executados antes da aplicação ser criada
    beforeCreate() {
        //Luiz Trindade - Verificar se o usuário está logado
    },

    //Luiz Trindade - Métodos que serão executados no início da aplicação
    mounted() {
        utils.loader("start");
        utils.loader();
    },

    //Luiz Trindade - Métodos
    methods: {
        redirecionarColabFood() {
            this.$router.push("/services/colab-food/");
        },

        //Solicitar acesso
        solicitarAcesso() {
            utils.loader("start");
            utils.informar("Aguarde, solicitando acesso...");

            setInterval(() => {
                const whatsappUrl = 'https://wa.me/5591986072393?text=Quero%20solicitar%20um%20acesso';
                window.location.href = whatsappUrl;

                utils.loader();
            }, 1000);
        }
    },

    computed: {
    },

    watch: {
    }
}
</script>

<style scoped>
.fade-in {
    opacity: 0;
    /* Começa invisível */
    animation: fadeIn 2.5s forwards;
    /* Aplica a animação */
}

@keyframes fadeIn {
    to {
        opacity: 1;
        /* Finaliza visível */
    }
}

#contentViewPage {
    top: 0;
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow-x: hidden;
    scroll-behavior: smooth;
    background-image: URL("../assets/colab-food/Sand\ to\ Blue.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

#siteNavBar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
    padding-top: 10px;
    padding-bottom: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, .5);

    /* background-color: rgba(255, 255, 255, .67) !important; */
    background-color: rgba(0, 0, 0, .67) !important;
    backdrop-filter: blur(8px);
}

#siteNavBar a {
    color: white !important;
    text-shadow: 2px 4px 6px rgba(0, 0, 0, .5);
}

#siteNavBar .navbar-toggler {
    color: white !important;
    text-shadow: 2px 4px 6px rgba(0, 0, 0, .5);
    text-shadow: 2px 4px 6px rgba(0, 0, 0, .5);
}

#logoNavBar {
    height: 50px;
    border-radius: 10px;
}

#mainContent {
    flex-grow: 1;
    padding-top: 100px;
    padding-bottom: 20px;
}

.containerShadow {
    text-shadow: 2px 4px 6px rgba(0, 0, 0, .5);
    box-shadow: 2px 4px 6px rgba(0, 0, 0, .5);
}

.container1 {
    background: rgb(2, 0, 36);
    background: linear-gradient(45deg, rgba(2, 0, 36, 1) 0%, rgba(9, 9, 121, 1) 50%, rgba(0, 212, 255, 1) 100%);
    border-radius: 10px;
    max-width: 90%;
    max-height: 90%;
    padding: 30px;
    box-shadow: 2px 4px 6px rgba(0, 0, 0, .5);
    color: white;
    margin-bottom: 20px;
}

.container2 {
    margin-bottom: 20px;
}

.container3 {
    margin-bottom: 20px;
}

.container4 {
    padding: 10px;
    border-radius: 10px;
    margin-bottom: 20px;
}

.ColabFood {
    background: rgb(255, 0, 0);
    background: linear-gradient(45deg, rgba(255, 0, 0, 1) 0%, rgba(255, 27, 0, 1) 50%, rgba(255, 97, 0, 1) 100%);
    border-radius: 10px;
    color: white;
    padding: 10px;
    text-shadow: 2px 4px 6px rgba(0, 0, 0, .5);
    box-shadow: 2px 4px 6px rgba(0, 0, 0, .5);
}

.membroContainer {
    background: rgb(0, 114, 152);
    background: linear-gradient(45deg, rgba(0, 114, 152, 1) 0%, rgba(0, 124, 111, 1) 50%, rgba(0, 92, 47, 1) 100%);
    border-radius: 10px;
    max-width: 90%;
    max-height: 90%;
    padding: 30px;
    box-shadow: 2px 4px 6px rgba(0, 0, 0, .5);
    color: white;
    margin-top: 10px;
    text-shadow: 2px 4px 6px rgba(0, 0, 0, .5);
    margin-bottom: 10px;
    font-size: 20px;
}

.membroImage {
    margin-top: 50px;
    height: 250px;
    border-radius: 10px;
    box-shadow: 2px 4px 6px rgba(0, 0, 0, .9);
}

.card {
    box-shadow: 0 4px 6px rgba(0, 0, 0, .5);
    border: none;
    color: white;
    background-color: rgba(0, 0, 0, .5);
    margin-top: 20px;
}

#footerSite {
    position: relative;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 1;
    padding-top: 10px;
    padding-bottom: 10px;
    box-shadow: 2 4px 6px rgba(0, 0, 0, .5);
}
</style>